/** @format */

import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import routes from "../routes";
function AccessibleNavigationAnnouncer() {
  const route = useHistory();
  const location = useLocation();
  const path = location.pathname.slice(1);

  const pageNoAuth = [
    "home",
    "upload-dokumen",
    "login",
    "forgot-password",
    "step-2-login",
    "kode-registrasi",
    "create-account",
    "verify-email",
    "reset-password",
    // "service-worker.js",
  ];
  const auth = useSelector((state: any) => state.auth);
  const kodeRole = auth?.data?.kode_role || null;
  if (!auth.isLogin) {
    const test = pageNoAuth.filter((item: any) => item.includes(path));
    if (!test.length) {
      route.push("/login");
    }
  } else {
    const checkPath =
      routes.find(
        (item: any) => item?.path === path || `${item?.path}/` === path,
      ) || null;
    if (checkPath?.access?.length) {
      if (!checkPath?.access.includes(kodeRole)) {
        route.push("/404");
      }
    }
  }
  return <></>;
}

export default AccessibleNavigationAnnouncer;
